"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8424],{

/***/ "./src/components/Landing/DiscoverMore.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _Elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");





const DiscoverMore = (param)=>{
    let { tagsData  } = param;
    if (!tagsData) return null;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("home");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bgColor: "gray.100",
        _dark: {
            bgColor: "whiteAlpha.50"
        },
        p: 8,
        pb: 20,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
            maxW: "1290px",
            mx: "auto",
            py: 8,
            px: 4,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                    fontWeight: "700",
                    color: "rankPageButtonText",
                    fontSize: 24,
                    children: t("DiscoverMoreHeading")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Wrap */ .Eq, {
                    mt: 8,
                    spacing: 4,
                    children: tagsData === null || tagsData === void 0 ? void 0 : tagsData.map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                            as: "li",
                            borderWidth: "1px",
                            px: 4,
                            py: 1,
                            fontSize: 24,
                            rounded: "full",
                            borderColor: "gray.300",
                            color: "gray.600",
                            fontWeight: "500",
                            href: "/tags/".concat(tag.id),
                            sx: {
                                "&:hover, &:focus, &:active": {
                                    bgColor: "gray.200",
                                    textDecoration: "none",
                                    boxShadow: "none",
                                    _dark: {
                                        bgColor: "whiteAlpha.400"
                                    }
                                }
                            },
                            _dark: {
                                color: "whiteAlpha.900",
                                borderColor: "whiteAlpha.700"
                            },
                            children: t(tag.id)
                        }, tag.id))
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DiscoverMore);


/***/ })

}]);